import React, { Fragment } from 'react';
import styles from './EventCalendarLoader.module.scss';
export const EventCalendarLoader = () => {
    const numOfLoaderBlocks = 24;
    const numOfLoaderRows = 5;
    return (<div className={styles.eventCalendarLoader}>
      {Array(numOfLoaderBlocks)
            .fill(0)
            .map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={i}>
            <div className={styles.eventCalendarLoaderDate}/>
            {Array(numOfLoaderRows)
                .fill(0)
                .map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={i} className={styles.eventCalendarLoaderRows}/>))}
          </Fragment>))}
    </div>);
};
